/**
 * The green "Sending to <name> · <email> · gets an email and a portal
 * notification" line under the people picker (proposal 7, kanban 0da0c669),
 * or, when the pick cannot go yet, the reason in words. Records each new
 * confirmed pick once.
 */
import { useEffect } from 'react';

import { trackEvent } from '../../services/portalTracking';
import { confirmParts, type RoutePick } from './routePickView';
import styles from './RoutePicker.module.css';

export function RouteConfirmLine({ pick, threadNo }: { pick: RoutePick; threadNo: string }) {
  const names = pick.kind === 'ready' ? pick.recipients.map((r) => r.name).join('|') : '';
  useEffect(() => {
    if (!names) return;
    trackEvent('action', 'qcp_route_match_confirmed', {
      thread_no: threadNo,
      names: names.split('|'),
    });
  }, [names, threadNo]);

  if (pick.kind !== 'ready') return null;
  const { names: who, detail } = confirmParts(pick.recipients);
  return (
    <div className={styles.confirm} role="status" data-testid="route-confirm">
      <strong className={styles.confirmWho}>Sending to {who}</strong>
      {detail.map((d) => (
        <span key={d} className={styles.confirmDetail}>
          {' · '}
          {d}
        </span>
      ))}
    </div>
  );
}

export default RouteConfirmLine;
